{
  "de": {
    "sortGroups": {
      "date": "Datum",
      "deadline": "Frist",
      "name": "Name"
    },
    "sorting": {
      "category_name_asc": "Kategorie A → Z",
      "category_name_desc": "Kategorie Z → A",
      "created_at_asc": "Älteste zuerst",
      "created_at_desc": "Neueste zuerst",
      "deadline_date_asc": "Späteste Frist zuerst",
      "deadline_date_desc": "Früheste Frist zuerst",
      "due_date asc": "Späteste Frist zuerst",
      "due_date desc": "Früheste Frist zuerst",
      "group_name asc": "Name A → Z",
      "group_name desc": "Name Z → A",
      "group_name_asc": "Name A → Z",
      "group_name_desc": "Name Z → A",
      "last_name_asc": "Nachname A → Z",
      "last_name_desc": "Nachname Z → A",
      "messaged_all_at_nulls_first_asc": "Älteste zuerst",
      "messaged_all_at_nulls_last_desc": "Neueste zuerst",
      "messaged_at_nulls_first_asc": "Älteste zuerst",
      "messaged_at_nulls_last_desc": "Neueste zuerst",
      "name_asc": "Name A → Z",
      "name_desc": "Name Z → A",
      "name_lower asc": "Name A → Z",
      "name_lower desc": "Name Z → A",
      "name_lower_asc": "Name A → Z",
      "name_lower_desc": "Name Z → A",
      "notification_level_name_asc": "Einheit A → Z",
      "notification_level_name_asc_sup": "Projekt A → Z",
      "notification_level_name_desc": "Einheit Z → A",
      "notification_level_name_desc_sup": "Projekt Z → A",
      "session_started_at_asc": "Älteste Sitzung zuerst",
      "session_started_at_desc": "Neueste Sitzung zuerst",
      "status asc": "Status A → Z",
      "status desc": "Status Z → A",
      "status_name_asc": "Status A → Z",
      "status_name_desc": "Status Z → A",
      "unit_name_asc": "Einheit A → Z",
      "unit_name_desc": "Einheit Z → A",
      "unit_name_lower_asc": "Einheit A → Z",
      "unit_name_lower_desc": "Einheit Z → A",
      "updated_at asc": "Älteste Aktualisierung zuerst",
      "updated_at desc": "Neueste Aktualisierung zuerst",
      "updated_at_asc": "Älteste Aktualisierung zuerst",
      "updated_at_desc": "Neueste Aktualisierung zuerst"
    }
  }
}
